import React from "react";
import ModalSkeleton from "../../components/ModalSkeleton";
import { LogoutIcon } from "../../constant";
import classes from "./ResetPassword.module.css";
import ModalAction from "../../components/ModalAction";
import { logout, setPassword } from "../../store/authSlice";
import { Input } from "../../components/Input";
import { forgotPasswordSchema } from "../../schema";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import useApi from "../../useApi";

const initialValues = {
  password: "",
};
const ResetPasswordModal = ({ show, setShow, onSubmit }) => {
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values) => {
      onSubmit(values);
    },
  });
  const {
    touched,
    errors,
    values,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
  } = formik;
  const handleChangeWithTouch = (field) => (value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };
  return (
    <>
      <ModalSkeleton
        title={"Reset Password"}
        width="500px"
        show={show}
        setShow={setShow}
      >
        <form onSubmit={handleSubmit} className={classes.wrapper}>
          <Input
            type="password"
            placeholder="Enter Password"
            label={"Password"}
            value={values?.password}
            onChange={handleChangeWithTouch("password")}
            errorText={touched?.password && errors?.password}
          />
          <ModalAction className={classes.bottomCtas} onConfirm={logout} />
        </form>
      </ModalSkeleton>
    </>
  );
};

export default ResetPasswordModal;
